export enum RadioGroupView {
  Default,
  List,
}

export default RadioGroupView
